import { IUnit } from '@/pages/Parameters/parameters.types.ts'
import useUnits from '@/pages/MDM/hooks/useUnits.ts'
import { useMemo } from 'react'

const useUnit = (id: IUnit['id']) => {
  const units = useUnits()

  return useMemo(() => {
    return units.find((u) => u.id === id)
  }, [id, units])
}

export default useUnit
